import { Container, Row, Col } from "react-bootstrap";
import { useMemo, useCallback, useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BzInputText, BzMasterAgGrid, BzToastMessage } from "../components";
import { toastConfig } from "../redux/actions/toast";
import { EDIS_PERMISSION_MESSAGE, ORDERS_LIMIT_IN_API, ORDERBOOK_API_ORDER_STATUS, DEPOSITORY_CDSL, ORDER_STATUS_FROM_RESPONSE, DEPOSITORY_NSDL, REVOKE_TAB, EDIS_FIT_CELL_CONTENT } from "../utils/global_variables";
import { _executeEdisOnline } from "../controllers";
import { getAllOrders } from "../redux/actions/orders";
import { updateEdisIsLoading } from "../redux/actions/edis";

const EdisRevokeScrip = (props) => {
    const { revokeScripsForGrid,
        edisRevokeURL,
        refreshEdisDataAfterFlow,
        multiIsinEnabled } = props;
    const [rowData, setRowData] = useState([]);
    const edisTableRef = useRef();
    const dispatch = useDispatch();
    const [settlementType, setSettlementType] = useState("T+1 (Next Day)");
    const userDPDetails = useSelector(state => state.auth.dpDetails);
    const allOrders = useSelector(state => state?.orders?.allOrders);
    const  toastRedux = useSelector(state => state?.toasts);
    const [toasts, setToasts] = useState()

    useEffect(() => {
        setToasts(toastRedux?.toasts)
    }, [toastRedux])
    useEffect(() => {
        // Setting row data for grid based on scripDetailsForGrid prop
        const rowDetails = revokeScripsForGrid.map(scrip => {
            return {
                sSecurityDesc: scrip.sSecurityDesc,
                authorizedQty: {
                    ApprovedQuantity: scrip.ApprovedQuantity,
                    eDISDPQty: scrip.eDISDPQty
                },
                eDISRevokeQty: scrip.ApprovedQuantity,
                nSettlementType: "T+1 (Next Day)",
                ApprovedQuantity: scrip.ApprovedQuantity,
                eDISDPQty: scrip.eDISDPQty,
                TodayFreeQty: scrip.TodayFreeQty,
                ClosePrice: scrip.ClosePrice,
                sISINCode: scrip.sISINCode,
                eDISCheckQty: scrip.eDISCheckQty,
            };
        });
        setRowData(rowDetails);
        return () => {
            dispatch(toastConfig({ show: false }));
        };
    }, [revokeScripsForGrid]);

    useEffect(() => {
        dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));
    }, [dispatch]);


    const revokeSummaryDetails = (edisScrips) => {
        let edisScripSummaryArr = edisScrips.filter(scrip => scrip.nSettlementType === settlementType);
        let dpDetailsEdis = null;
        let dataPayloadEdis = null;
        dpDetailsEdis = {
            ...userDPDetails.data,
            "ISIN": "",
            "securityDescription": ""
        };
        if (edisScripSummaryArr.length > 0) {
            dataPayloadEdis = {
                dpDetails: { ...dpDetailsEdis },
                scripsData: [...edisScripSummaryArr],
                isMultiIsin: multiIsinEnabled,
                edisURL: edisRevokeURL,
                tab: "revoke"
            };
        }
        return dataPayloadEdis;
    };
    const checkUpdatedQuantity = () => {//To enable disable button in toaster whenever quantity reach zero
        const isAnyRevokeQtyZero = edisTableRef?.current?.api?.getSelectedRows()?.some(item => item.eDISRevokeQty === 0);
        setToasts(prev=>prev.map(toast => {
            const updatedToast = { ...toast, button: toast?.button?.map(item => item ? { ...item, bIsDisabled: isAnyRevokeQtyZero } : item) }
            dispatch(toastConfig({ ...updatedToast, renderSingle: true }))
            return updatedToast
        }))
    }
    const suppressKeyboardEvent = (params) => {//to disable default behaviour of ag grid on up and down arrow key
        const { event } = params;
        const key = event.key;
        if (['ArrowUp', 'ArrowDown'].includes(key)) {
            return true;
        }
        return false
    }
    const SampleCellRenderer = (props) => {
        const handleRequestQtyChange = (e) => {
            if ((userDPDetails?.data?.sDepository === DEPOSITORY_NSDL || userDPDetails?.data?.sDepository === DEPOSITORY_CDSL) && Number(e.target.value) <= Number(props.data.authorizedQty.ApprovedQuantity) && !e.target.value.includes('-')) {
                props.setValue(Number(e.target.value));
                checkUpdatedQuantity();
            } else { }
            // Number(e.target.value) !== 0 && Number(e.target.value) <= Number(props.data.authorizedQty.ApprovedQuantity) ? props.setValue(Number(e.target.value)) : props.setValue(props.data.eDISRevokeQty);
        };

        const handlePlusMinusBtnClick = (action) => {
            switch (action) {
                case "add": {
                    if (Number(props?.getValue()) < Number(props.data.authorizedQty.ApprovedQuantity)) {
                        props.setValue((Number(props?.getValue()) + 1));
                    }
                    break;
                }
                case "sub": {
                    if (Number(props?.getValue()) > 1) {
                        props.setValue((Number(props?.getValue()) - 1));
                    }
                    break;
                }
                default:
                    break;
            }
            checkUpdatedQuantity();
        };
        const checkIsSelected = (props) => {
            if (props?.api?.getSelectedRows()?.length) {
                return props?.api?.getSelectedRows()?.some((each) => each?.sISINCode === props?.data?.sISINCode);
            }
        };
        const onQuantityInputsKeyDown = (e) => {
            if (e.which === 38 || e.which === 40) {
                e.preventDefault();
                if (e.which === 38) {
                    handlePlusMinusBtnClick("add");
                } else if (e.which === 40) {
                    handlePlusMinusBtnClick("sub");
                } else { }
            }
        };
        return (
            <Container fluid className='p-0'>
                <Row className='g-0 mt-1'>
                    <Col md={6} className='mrgauto'>
                        <div className={`input-group postion-relative ${(!checkIsSelected(props) || userDPDetails.data.sDepository === DEPOSITORY_CDSL) ? `disabled` : null}`}>
                            <div className='icon-12 icon-order-decrease input-number-left-wrap' onClick={() => { if (checkIsSelected(props) && userDPDetails.data.sDepository !== DEPOSITORY_CDSL) { handlePlusMinusBtnClick("sub"); } }}></div>
                            <BzInputText size='sm' autoComplete="off" type="text" className='text-center form-control' name="firstLeg" onChange={(e) => handleRequestQtyChange(e)} value={props?.getValue()} disabled={!checkIsSelected(props) || userDPDetails.data.sDepository === DEPOSITORY_CDSL} onKeyDown={onQuantityInputsKeyDown} />
                            <div className='icon-12 icon-order-increase input-number-right-wrap' onClick={() => { if (checkIsSelected(props) && userDPDetails.data.sDepository !== DEPOSITORY_CDSL) { handlePlusMinusBtnClick("add"); } }} ></div>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    };

    const onRowSelected = (event) => {
        // Refresh cells so custom components in grid can be updated and get updated data like if node is selected
        event.api.refreshCells({ force: true });
        if (edisTableRef.current && event.api.getSelectedNodes().length > 0) {
            const isAnyRevokeQtyZero = edisTableRef?.current?.api?.getSelectedRows()?.some(item => item.eDISRevokeQty === 0);
            dispatch(toastConfig({
                renderSingle: true, //this is important when you only want one toaster to render
                autoDismiss: false,
                show: true,
                message: EDIS_PERMISSION_MESSAGE.replace("{0}", edisTableRef.current.api.getSelectedRows().length),
                button: [{
                    btnName: "Revoke",
                    type: "REVOKE_SCRIPS_FOR_EDIS",
                    className: 'btn btn-solid ms-3',
                    bIsDisabled: isAnyRevokeQtyZero,
                    onClickHandler: () => {
                        dispatch(updateEdisIsLoading(true));
                        _executeEdisOnline(revokeSummaryDetails(event.api.getSelectedRows()),REVOKE_TAB).then((response) => {
                            refreshEdisDataAfterFlow();
                            dispatch(updateEdisIsLoading(false));
                            // Call controller function to  UL generatehere
                        }).catch((error) => {
                            dispatch(updateEdisIsLoading(false));
                            dispatch(toastConfig({
                                renderSingle: true,
                                autoDismiss: false,
                                show: true,
                                message: <div>EDIS Transaction failed.</div>,
                                button: [
                                    {
                                        btnName: "OK",
                                        type: "OK",
                                        className: 'btn btn-solid ms-3',
                                        onClickHandler: () => {
                                            event.api.deselectAll();
                                            event.api.selectAll();
                                        }
                                    }
                                ]
                            }));
                        });
                    }
                }]
            }));
        }
        else {
            dispatch(toastConfig({ show: false }));
        }
    };
    const onRowDataUpdated = () => {
        if (edisTableRef.current) {
            edisTableRef.current.api.sizeColumnsToFit();
            // Select all nodes when coming from hamburger menu
            edisTableRef.current.api.sizeColumnsToFit();
            edisTableRef.current.api.selectAll();
        }
    };

    const handleEdisTableScripSearch = useCallback(() => {
        edisTableRef.current.api.setQuickFilter(
            document.getElementById('edis_scrips_header_search').value
        );
    }, []);

    const GridHeaderSearch = ({ className, ...props }) => {
        props.column.addEventListener('filterChanged');
        return <div className='position-relative'>
            <div className='icon-14 icon-search icon-grey search-icon-position'></div>
            <BzInputText size="sm" className={`${className} scripname-searchtext p-l-30`} id="edis_scrips_header_search" onInput={handleEdisTableScripSearch} type="search" placeholder="Search" />
        </div>;
    };

    const getOrderStatus = useCallback((props) => {
        const orderScripInfo = allOrders?.filter(order => order.sISINCode === props.data.sISINCode);
        if (userDPDetails.data.sDepository === DEPOSITORY_CDSL && (orderScripInfo[0]?.status === ORDER_STATUS_FROM_RESPONSE.PENDING || orderScripInfo[0]?.status === ORDER_STATUS_FROM_RESPONSE.EXECUTED || orderScripInfo[0]?.status === ORDER_STATUS_FROM_RESPONSE.COMPLETED)) {
            return false;
        } else {
            return true;
        }
    }, [allOrders, userDPDetails]);


    const rowSelection = useMemo(() => {
        return {
            mode: 'multiRow',
            isRowSelectable: (rowNode) => getOrderStatus(rowNode)
        };
    }, [getOrderStatus]);

    const columnDefs = useMemo(() => [
        {
            colId: "check",
            headerCheckboxSelection: true,
            showDisabledCheckboxes: true,
            maxWidth: 40,
            resizable: false,
            suppressMenu: true,
            sortable: false,
        },
        {
            field: "sSecurityDesc",
            headerComponent: GridHeaderSearch,
            resizable: false,
            suppressMenu: true,
        },
        {
            field: "authorizedQty",
            headerName: "AUTHORIZED QUANTITY",
            cellRenderer: (params) => <p>{params.data.authorizedQty.ApprovedQuantity} of {params.data.authorizedQty.eDISDPQty}</p>,
            suppressMovable: true,
            suppressNavigable: true,
            resizable: false,
            suppressMenu: true,
        },
        {
            field: "eDISRevokeQty",
            headerName: "REVOKE QUANTITY",
            cellRenderer: SampleCellRenderer,
            resizable: false,
            suppressMenu: true,
        },
        {
            field: "nSettlementType",
            headerName: "SETTLEMENT",
            resizable: false,
            suppressMenu: true,
        },
    ], [revokeScripsForGrid, allOrders]);

    return (
        <>
            <BzToastMessage />
            <Container fluid className='p-0'>
                <Row className='g-0'>
                    <Col>
                        <div>
                            <BzMasterAgGrid
                                rowSelection={rowSelection}
                                arrColumnData={columnDefs}
                                arrRowData={rowData}
                                ref={edisTableRef}
                                className="ag-theme-alpine edis-ag-grid-wrapper"
                                onRowDataUpdated={onRowDataUpdated}
                                onRowSelected={onRowSelected}
                                isCompress={true}
                                defaultColProps={{ flex: 1,suppressKeyboardEvent }}
                                gridProfileType={EDIS_FIT_CELL_CONTENT}
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );

};

export default EdisRevokeScrip;